import { render, staticRenderFns } from "./my-orders.vue?vue&type=template&id=57455140"
import script from "./my-orders.vue?vue&type=script&lang=js"
export * from "./my-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports